import dayjs from 'dayjs';
// eslint-disable-next-line import/no-cycle
import Tabulator from 'tabulator-tables';
import { Modal } from '~/scripts/services/modal/modal';
// eslint-disable-next-line import/no-cycle
import { viewFile } from '../ktable/columnFactory';

/** @type {Ktable.GetFormatterFnHTML} */
export const fileThumbFormatter = (
	cell,
	column,
	settings,
	$injector,
) => {
	if (cell) {
		if (cell.file === 0) {
			const icon = document.createElement('i');
			icon.title = 'Aucun fichier disponible';
			icon.classList.add('fa');
			// icon.classList.add('fa-exclamation-circle');
			return icon;
		}
		const image = document.createElement('img');
		image.alt = 'document';
		image.width = 14;
		image.setAttribute('pw', 'thumb');

		if (cell?.thumb_icon) {
			image.src = `data:image/png;base64,${cell.thumb_icon}`;
		}

		image.addEventListener('click', async event => {
			event.stopPropagation();
			event.preventDefault();
			if (cell.kid && cell.kid !== 'NONE' && $injector) {
				await viewFile(cell.kid, $injector);
			}
		});

		return image;
	}

	const icon = document.createElement('i');
	icon.title = 'Aucun fichier disponible';
	icon.classList.add('fa');
	icon.classList.add('fa-file-o');

	return icon;
};

export const baseFormatter = (/** @type {string | HTMLElement} */ content) => {
	/** @type {Ktable.GetFormatterFn} */
	const returnValue = (
		cell,
		column,
		settings,
		$injector,
		isTooltip = false,
	) => {
		if (cell?.file !== 0 && cell?.thumb_icon) {
			const thumbContent = fileThumbFormatter(cell, column, settings, $injector);

			const span = document.createElement('span');
			span.classList.add('element');

			// Add space in the right of the icon, when there is text
			thumbContent.classList.add('mr-8');

			span.append(thumbContent);
			span.append(content);

			if (isTooltip) {
				// @ts-ignore
				return span.textContent;
			}

			return span;
		}

		if (isTooltip) {
			if (typeof content === 'string') {
				return content;
			}
			// @ts-ignore
			return content.textContent;
		}

		const div = document.createElement('div');
		// @ts-ignore
		div.innerHTML = content;

		return div;
	};
	return returnValue;
};

/** @type {Ktable.GetFormatterFn} */
export const emailFormatter = (
	cell,
	column,
	settings,
	$injector,
	isTooltip,
) => {
	if (cell?.name) {
		const link = document.createElement('a');
		link.target = '_blank';
		link.href = `mailto:${cell.name}`;
		link.textContent = cell.name.toString();
		return baseFormatter(link)(cell, column, settings, $injector, isTooltip);
	}
	return baseFormatter('')(cell, column, settings, $injector, isTooltip);
};

/** @type {Ktable.GetFormatterFn} */
export const stringFormatter = (
	cell,
	column,
	settings,
	$injector,
	isTooltip,
) => {
	const content = cell?.name?.toString() ?? '';
	const a = baseFormatter(content)(cell, column, settings, $injector, isTooltip);
	return a;
};

/** @type {Ktable.GetFormatterFn} */
export const dateFormatter = (
	cell,
	column,
	settings,
	$injector,
	isTooltip,
) => {
	const content = cell?.name ? dayjs(cell.name).format(settings?.format ?? 'DD/MM/YYYY') : '';
	return baseFormatter(content)(cell, column, settings, $injector, isTooltip);
};

/** @type {Ktable.GetFormatterFn} */
export const urlFormatter = (
	cell,
	column,
	settings,
	$injector,
	isTooltip,
) => {
	if (cell?.name) {
		const link = document.createElement('a');
		link.target = '_blank';
		link.href = cell.name.toString();
		// @ts-ignore
		link.textContent = cell.url_name;
		const fmt = baseFormatter(link)(cell, column, settings, $injector, isTooltip);
		if (isTooltip) {
			return link.href;
		}
		return fmt;
	}
	return baseFormatter('')(cell, column, settings, $injector, isTooltip);
};

/**
 *
 * @param {Tabulator} table
 * @returns {any}
 */
export const rowSelectionK = table =>
/**
 *
 * @param {*} cell
 * @param {{ $injector: import('angular').auto.IInjectorService; rowRange: any }} formatterParameters
 * @returns
 */
	// eslint-disable-next-line implicit-arrow-linebreak
	(
		cell,
		formatterParameters,
	) => {
		let checkbox = document.createElement('input');

		checkbox.type = 'checkbox';

		// @ts-ignore
		if (table.modExists('selectRow', true)) {
			checkbox.addEventListener('click', event => {
				event.stopPropagation();
			});

			// When single row
			if (typeof cell.getRow === 'function') {
				const row = cell.getRow();

				// @ts-ignore
				if (row instanceof Tabulator.RowComponent) {
					checkbox.addEventListener('change', () => {
						row.toggleSelect();
					});

					checkbox.checked = row.isSelected && row.isSelected();
					table.modules.selectRow.registerRowSelectCheckbox(row, checkbox);
				}
				else {
					// @ts-ignore
					checkbox = '';
				}
			}
			// When header
			else {
				checkbox.addEventListener('change', async () => {
					const filters = table.getFilters(true);
					const filtersCount = filters.length;

					const selectedRows = table.getRows('selected');

					if (filtersCount === 0 || selectedRows.length === 0) {
						if (table.modules.selectRow.selectedRows.length > 0) {
							table.deselectRow();
						}
						else {
							table.selectRow(formatterParameters.rowRange);
						}
					}
					else {
						const injector = formatterParameters.$injector;
						const $translate = injector.get('$translate');

						const modal = new Modal(injector);
						const answer = await modal.open({}, {
							title: $translate.instant('object.confirm-delete-title'),
							body: '<p>D\'autres éléments du tableau sont actuellement sélectionnés. Que souhaitez vous faire?</p>',
							buttons: [
								{
									label: 'Remplacer la sélection',
									// type: '',
									action: 'close',
									value: 'replace',
								},
								{
									label: 'Ajouter à la sélection',
									action: 'close',
									value: 'add',
								},
								{
									label: 'Annuler',
									type: 'warning',
									action: 'close',
									value: 'cancel',
								},
							],
						});

						if (answer === 'replace') {
							table.deselectRow();
							table.selectRow(formatterParameters.rowRange);
						}
						else if (answer === 'add') {
							table.selectRow(formatterParameters.rowRange);
						}
					}
				});

				table.modules.selectRow.registerHeaderSelectCheckbox(checkbox);
			}
		}
		return checkbox;
	};
